import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  TextField,
  Typography,
  Stack
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { AuthenticationType } from 'components/status-checks/authentication-form-utils'
import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'

import type { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const ObservabilityToolAuthenticationTypeToggle = () => {
  const { control, trigger } = useFormContext<StatusCheckFormValues>()

  const authenticationType = useWatch<StatusCheckFormValues>({
    control,
    name: 'authenticationType'
  })

  return (
    <FormControl>
      <Controller
        control={control}
        name="authenticationType"
        render={({ field }) => {
          return (
            <RadioGroup
              {...field}
              onChange={(e) => {
                const value = e.target.value as AuthenticationType
                field.onChange(value)

                trigger(['headers', 'secret'])
              }}
            >
              <FormControlLabel
                control={<Radio />}
                label="Use Authorization Header"
                value={AuthenticationType.AuthorizationHeader}
              />
              {authenticationType ===
                AuthenticationType.AuthorizationHeader && (
                <Stack sx={{ my: 2 }}>
                  <ObservabilityToolHeaders />
                </Stack>
              )}
              <FormControlLabel
                control={<Radio />}
                label={
                  <Typography>
                    Retrieve credentials from AWS Secrets manager
                  </Typography>
                }
                value={AuthenticationType.AWSSecretsManager}
              />
              <Typography color="text.secondary" variant="caption">
                This AWS ARN should point to a secret in Secrets Manager. We
                retrieve the credentials at runtime when executing a health
                check.
              </Typography>
              {authenticationType === AuthenticationType.AWSSecretsManager && (
                <Controller
                  control={control}
                  name="secret"
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      required
                      error={Boolean(error)}
                      helperText={error?.message}
                      label="AWS ARN"
                      sx={{
                        mt: 2
                      }}
                      variant="outlined"
                    />
                  )}
                />
              )}
            </RadioGroup>
          )
        }}
      />
    </FormControl>
  )
}
